import { makeStyles } from '@material-ui/core/styles';

export const useStyles: any = makeStyles((theme) => ({
    wrapper: {
        backgroundColor: '#cad7e0',
        padding: '10px',
        fontWeight: 500,
        fontSize: '1rem',
        color: '#000',
        textAlign: 'center',
        [theme.breakpoints.down(600)]: {
            padding: '10px 0',
        },
    },
    header: {
        fontWeight: 600,
    },
    box: {
        margin: '30px auto',
    },
    top: {
        textAlign: 'center',
        fontWeight: 600,
        padding: '1.2rem',
    },
}));
